import React, { useEffect } from "react";

import Main from '../components/MarketsCrypto/Main'
import WhatIsCrypto from "../components/MarketsCrypto/WhatIsCrypto";
import WhyChooseCFD from "../components/MarketsCrypto/WhyChooseCFD";
import ControlRisk from "../components/MarketsCrypto/ControlRisk";

import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import NeedHelp from "../components/Home/NeedHelp";

function MarketsCrypto () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Main/>
            <WhatIsCrypto/>
            <WhyChooseCFD/>
            <ControlRisk/>
            <WhyArvest/>
            <ArvestOffers/>
            <NeedHelp/>
        </div>
    );
}

export default MarketsCrypto;